<template>
  <div class="popover-menu-header">
    <div v-if="hasSlotActions" class="popover-menu-header__actions">
      <slot name="actions" />
    </div>

    <div class="popover-menu-header__title">
      <slot name="title" />
    </div>

    <Btn
      v-if="close"
      @click="$emit('cancel')"
      color="ghost"
      size="medium"
      class="popover-menu-header__close"
      icon
      data-test-id="overlay-card-close-button"
    >
      <CloseIcon16 />
    </Btn>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CloseIcon16 from '@/components/Icons/CloseIcon16.vue';
import { hasSlotContent } from '@components/slots';

export default defineComponent({
  emits: { cancel: null },
  name: 'PopoverMenuHeader',

  components: {
    CloseIcon16,
  },

  props: {
    close: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hasSlotActions() {
      return hasSlotContent(this.$slots.actions, {});
    },
  },
});
</script>

<style lang="scss">
.popover-menu-header {
  padding: 8px 8px 0 8px;
  display: flex;
}

.popover-menu-header__actions {
  display: flex;
  gap: 8px;
}

.popover-menu-header__title {
  padding-left: 8px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  padding-top: 5px;
  display: grid;
}

.popover-menu-header__close {
  margin-left: auto;
}
</style>
